<template>
  <div class="dialog-wrapper" :class="wrapperClassName">
    <transition appear name="fade">
      <div class="overlay">
        <div class="dialog-box">
          <div v-if="title" class="dialog-box__title">
            {{ title }}
          </div>
          <div class="dialog-box__main m-b-5">
            <slot />
          </div>
          <div v-if="buttons.length" class="dialog-box__controls">
            <div
              v-for="(btn, index) in buttons"
              :key="index"
              :class="btn.class ? ['btn', ...btn.class] : ['btn']"
              :style="{ minWidth: '40%' }"
              @click="btn.callback"
            >
              {{ btn.name }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export type ButtonType = {
  name: string;
  class?: string[];
  callback: () => void;
};

@Component
export default class Dialog extends Vue {
  @Prop({ default: '' }) readonly text!: string;
  @Prop({ default: '' }) readonly title!: string;
  @Prop(String) readonly wrapperClassName!: string;
  @Prop({ default: () => [] }) readonly buttons!: ButtonType[];
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variable.scss';
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(black, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-box {
  font-size: $size-m;
  width: 32rem;
  background: $dialog-default-background;
  color: $darker-text;
  text-align: center;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  box-shadow:
    0 3px 24px 0 rgba(0, 0, 0, 0.3),
    0 0 24px 0 rgba(0, 0, 0, 0.22);
  border-style: solid;
  border-width: 0.5px;
  border-image-source: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 0.4) 5%,
    rgba(255, 255, 255, 0) 20%,
    rgba(255, 255, 255, 0)
  );
  padding: 3rem 2rem 1.5rem;

  &__title {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: $darker-text;
  }

  &__main {
    width: 100%;
  }

  &__controls {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .btn {
      padding: 0.8rem 2.6rem;
      border: none;
      text-align: left;
      flex: 1;
      margin: 5px;
      font-size: $size-m;
      cursor: pointer;
    }
  }
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
